import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ShippingProvider } from '../../interfaces/ShippingProvider/ShippingProvider';
import { getShippingProviders } from '../../api/ShippingProvider';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { ShippingProvidersTable } from './ShippingProvidersTable';

export const ShippingProvidersPage = () => {
  const navigate = useNavigate();

  const [shippingProviders, setShippingProviders] = useState<
    ShippingProvider[]
  >([]);
  const [loading, setLoading] = useState(false);

  const refreshShippingProviders = () => {
    setLoading(true);
    getShippingProviders()
      .then((sp) => setShippingProviders(sp))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshShippingProviders();
  }, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Kargo Firmaları
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/shipping/providers/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Kargo Firması
      </Button>
      <ShippingProvidersTable shippingProviders={shippingProviders} />
    </Box>
  );
};
